module.exports = __webpack_public_path__ + "img/pdf-icon.74746614.png";